export default "__VITE_ASSET__BgBEh2mx__"